import { render } from "./Purchase_add.vue?vue&type=template&id=9130327c"
import script from "./Purchase_add.vue?vue&type=script&lang=js"
export * from "./Purchase_add.vue?vue&type=script&lang=js"

import "./Purchase_add.vue?vue&type=style&index=0&id=9130327c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__